"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3PkgInfo = void 0;
/* eslint-disable header/header */ exports.Web3PkgInfo = { version: '4.0.1' };
//# sourceMappingURL=version.js.map